import { api } from './../../api.js';
import { config } from './../../config.js';
import { loadConfig } from './../../configLoader.js';

const state = {
    config : null,
    dynamicConfig: {}
}

const getters = {
    getConfig: state => state.config,
    getDynamicConfig: state => state.dynamicConfig
}

const mutations = {
    setConfig : (state, config) => {
        var hash_teatro = config.data.hash_teatro;
        if(hash_teatro === 'jPrFr1rSNcqbXShv50cb' || hash_teatro === 'YPY8EVtyoYMWay0EHAmN' || hash_teatro === 'UmeRCe3vusTW1LYct845') {
            var descuentos = [
                'JÓVENES ENTRE 14 Y 25 AÑOS - 15',
                'MAYORES DE 65 AÑOS - 15',
                'DESEMPLEADOS - 15',
                'FAMILIAS NUMEROSAS - 15',
                'ESTUDIANTES CONSERVATORIO DANZA - 15',
                'ESTUDIANTES CONSERVATORIO MÚSICA - 15',
                'GRUPOS DE 15 O MÁS - 15',
                'ESCUELA SUPERIOR ARTE DRAMÁTICO - 15',
                'UNIVERSITARIOS - 15',
                'MURCIA TOURIST CARD - 15',
                'ERASMUS STUDENTS CARD - 15',
                'ASOC. ACTORES DE LA REGIÓN DE MURCIA - 15',
                'ASOC. PROFESIONALES CIRCO REGIÓN MURCIA - 15',
                'ASOC.DRAMATURGOS REGIÓN MURCIA - 15',
                'ASOCIACIÓN MURCIA ESCENA - 15',
                'ASOC. DIRECTORES REGIÓN DE MURCIA - 15',
                'ASOCIACIÓN PLATAFORMA 44 - 15',
                'ASOCIACIÓN FATEAMUR - 15',
                'UNIDADES FAMILIARES MONOPARENTALES - 15',
            ]

            config.data.descuentos_disponibles = descuentos.concat(config.data.descuentos_disponibles);
        }

        state.config = config.data;
    },
    setDynamicConfig : (state, dynamicConfig) => {
        state.dynamicConfig = dynamicConfig;
    }
}

const actions = {
    CONFIG : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('config'), data).then(res => {
                localStorage.setItem('hash_teatro', res.data.hash_teatro)
                commit('setConfig', res);
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_CLUBES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.clubes'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_PROVINCIAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.provincias'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_LOCATIONS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.locations'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_DIVISIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.divisiones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_GENEROS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.generos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SOLICITAR_DEVOLUCION : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('solicitar.devolucion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    async LOAD_DYNAMIC_CONFIG({ commit }) {
        try {
            const dynamicConfig = await loadConfig();
            commit('setDynamicConfig', dynamicConfig);
            return dynamicConfig;
        } catch (error) {
            console.error('Error loading dynamic config:', error);
            throw error;
        }
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};
